import * as Sentry from '@sentry/react';
import { FC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { isHubSignInEnabled } from 'services/hub-auth-service';
import { HUB_CALLBACK_PATH } from 'services/hub-callback';
import ComposeProviders from 'state/providers';
import Routes from '../routes';
import AuthCallback from './account/auth-callback';
import ForgotPassword from './account/forgot-password';
import Login from './account/login';
import Authentication from './authentication';
import Header from './header';
import { Main, MainContainer, MainContent } from './layout-styles';
import SessionExpirationGuard from './session-guard';

const ErrorFallback = () => (
  <div style={{ padding: '20px', textAlign: 'center' }}>
    <h1>Something went wrong</h1>
    <p>We&apos;ve been notified and are working to fix the issue.</p>
    <button type='button' onClick={() => window.location.reload()}>
      Reload Page
    </button>
  </div>
);

const App: FC = () => (
  <Sentry.ErrorBoundary fallback={ErrorFallback}>
    <BrowserRouter basename='/'>
      <SessionExpirationGuard />
      <Switch>
        <Route exact path='/login' render={(props) => <Login {...props} />} />
        <Route exact path='/forgot-password' render={(props) => <ForgotPassword {...props} />} />
        {isHubSignInEnabled() && <Route exact path={HUB_CALLBACK_PATH} component={AuthCallback} />}

        <Route
          path='/'
          render={(props) => (
            <ComposeProviders>
              <Authentication {...props}>
                <MainContainer>
                  <MainContent>
                    <Header {...props} />
                    <Main>
                      <Routes />
                    </Main>
                  </MainContent>
                </MainContainer>
              </Authentication>
            </ComposeProviders>
          )}
        />
      </Switch>
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);

export default App;
